import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export const documentOptions = {}

const initialState = {
  isKickBackModalOpen: false,
  stages: { from: null, to: null },
  kickBackApplication: null,
  kickBackModalClosedCallback: null,
}

const kickBackSlice = createSlice({
  name: 'kickback',
  initialState,
  reducers: {
    setIsKickBackModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isKickBackModalOpen = action.payload
    },
    setStages: (
      state,
      action: PayloadAction<{
        from: { label: string; value: string }
        to: { label: string; value: string }
      }>
    ) => {
      state.stages = action.payload
    },
    setKickBackApplication: (state, action: PayloadAction<string>) => {
      state.kickBackApplication = action.payload
    },
    setKickBackModalClosedCallback: (state, action: PayloadAction<(state?: string) => void>) => {
      state.kickBackModalClosedCallback = action.payload
    },
  },
})

export const {
  setIsKickBackModalOpen,
  setStages,
  setKickBackApplication,
  setKickBackModalClosedCallback,
} = kickBackSlice.actions

export const kickBackReducer = kickBackSlice.reducer
